import React from "react";
import { DropTarget } from "react-dnd";
import DeleteForever from "@material-ui/icons/DeleteForever";
import _ from "lodash";
import JobUtils from "../../utils/JobsUtils";
import {dropBoxStyle, placeHolderStyle} from "./DeliveryDropArea.styles";

const collect = (connect, monitor) => {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true }),
    canDrop: monitor.canDrop(),
    itemType: monitor.getItemType(),
  };
};

const dropTargetHandler = {
  drop(props, monitor, component) {
    let isDragAll = _.isEmpty(monitor.getItem().data);
    let data = isDragAll ? monitor.getItem().items : monitor.getItem().data;
    let source = !isDragAll ? data.sources[0] : data;
    let dependencyArray = _.get(component, "props.dependencyArray");
    let process = _.get(data, "process", null);
    let deliveryOption = _.get(component, "props.deliveryOption");    
    //Check for allowed processes with delivery
    if (!_.isEmpty(dependencyArray) && !_.isEmpty(process) && !_.isEmpty(deliveryOption)) {
      let dependency = _.find(dependencyArray, (item) => _.get(item, "key") === _.get(process, "screenerType"));
      //If not included in allowedMethods then discard entry
      if (!_.includes(_.get(dependency, "allowedMethods"), deliveryOption)) {
        props.setEventDeliveryFlag({key:_.get(process, "screenerType")})
        return { moved: false };
      }
    }
    if (_.isArray(source)) {
      let clonned = [...component.state.sources];
      let concatBoth = clonned.concat(source);
      let updatedList = _.unionBy(concatBoth, "key");
      component.setState(
        {
          sources: updatedList,
        },
        () => {
          component.props.onSourceDragged(component.state.sources, component.props.processList);
        }
      );
      return { moved: true };
    } else {
      let sourceKey = _.get(source, "key");
      let processKey = _.get(process, "key");
      let isValidAddition = true;
      if (process) {
        let hasMapping = _.has(component.props.deliveriesToSourceMapping, sourceKey + "_" + processKey);
        let hasDeliveryKey = false;
        if (hasMapping) {
          let map = _.get(component.props.deliveriesToSourceMapping, sourceKey + "_" + processKey);
          hasDeliveryKey = _.includes(map, component.props.index);
        }
        isValidAddition = !hasMapping || !hasDeliveryKey;
      } else {
        let oldRec = _.find(component.state.sources, (sourceRecord) => {
          return _.get(sourceRecord, "key") === _.get(source, "key");
        });
        isValidAddition = oldRec == null;
      }

      //Condition added to avoid duplicate record dragging
      if (component.state.sources && isValidAddition) {
        component.setState(
          {
            sources: [...component.state.sources, source],
          },
          () => {
            component.props.onSourceDragged(component.state.sources, process);
          }
        );
        return { moved: true };
      } else {
        return { moved: false };
      }
    }
  },
};

class DeliveryDropComponent extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      sources: [],
      process: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    let index = nextProps.index;
    let deliveriesToSourceMapping = nextProps.deliveriesToSourceMapping;
    let sl = nextProps.sourceList;
    let pl = nextProps.processList;
    if (_.isEmpty(pl)) {
      let sourceList = _.filter(sl, (source) => {
        let delMap = deliveriesToSourceMapping[_.get(source, "key")];
        return _.indexOf(delMap, index) > -1 ? true : false;
      });
      this.setState({ sources: sourceList });
    } else {
      let sourceList = [];
      let processList = [];
      let keys = _.keys(deliveriesToSourceMapping);
      _.map(keys, (key) => {
        let spKey = key.split("_");
        let sourceKey = spKey[0];
        let processKey = spKey[1];
        let delMap = deliveriesToSourceMapping[key];
        let contains = _.indexOf(delMap, index) > -1 ? true : false;
        if (contains) {
          sourceList.push(_.find(sl, (s) => _.get(s, "key") === parseInt(sourceKey)));
          processList.push(_.find(pl, (p) => _.get(p, "key") === parseInt(processKey)));
        }
      });
      this.setState({ sources: sourceList, process: processList });
    }
  }

  generateDisplayName(jobType, sourceLocation, item, jobKeysToFilename, process) {
    let mapping = !_.isEmpty(process) ? _.get(item, "key") + "_" + _.get(process, "key") : _.get(item, "key");
    let fileName = JobUtils.getDefaultFileName(jobType, sourceLocation, item, _.get(jobKeysToFilename, mapping), process, this.props.stitchAssetName, this.props.isStitch);
    let processName = "";
    if (!_.isEmpty(process)) {
      processName = _.get(process, "screenerType", "");
    }
    return _.isEmpty(process) || !_.has(process, "screenerType", false) ? fileName : fileName + "(" + _.capitalize(processName) + ")";
    // return fileName;
  }

  render() {
    let connectDropTarget = this.props.connectDropTarget;
    let onSourceDelete = this.props.handleSourceDelete;
    let jobType = this.props.jobType;
    let sourceLocation = this.props.sourceLocation;
    let jobKeysToFilename = this.props.jobKeysToFilename;
    let process = this.state.process;
    let canDrop = this.props.canDrop;
    let isOver = this.props.isOver;
    let isUnmapped = this.props.isUnmapped;

    const items = _.map(this.state.sources, (item, index) => {
      return (
        <li style={{ listStyleType: "none" }} key={_.uniqueId(_.get(item, "key", index))}>
          <div style={{ padding: "5px" }}>
            <span>{this.generateDisplayName(jobType, sourceLocation, item, jobKeysToFilename, process[index])}</span>
            
            <DeleteForever
              style={{ fill: "#A94442", float: "right", cursor: "pointer"}}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                const updatedData = _.filter(this.state.sources, (entry, indexing) => {
                  return _.get(item, "key", index) !== _.get(entry, "key", indexing);
                });
                this.setState(
                  {
                    sources: updatedData,
                  },
                  () => {
                    onSourceDelete(item, process[index]);
                  }
                );
              }}>
              Remove
            </DeleteForever>
          </div>
        </li>
      );
    });
    return connectDropTarget(
      <div
        style={
          _.isEmpty(items)
              ? {...placeHolderStyle,
                  ...dropBoxStyle,
                  border: isUnmapped ? "1px solid #FF0000" : "1px solid #9F9C9C",
                  boxShadow: isOver && canDrop ? "0 0 0 .3rem rgba(0,123,255,.25)" : ""}
              : {...dropBoxStyle,
                  boxShadow: isOver && canDrop ? "0 0 0 .3rem rgba(0,123,255,.25)" : ""}}>
        {_.isEmpty(items) ? "Drag file(s) here" : items}
      </div>
    );
  }
}

export default DropTarget(["source", "items"], dropTargetHandler, collect)(DeliveryDropComponent);
